import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disabled"],
  _excluded2 = ["children", "href", "disabled"];
import styled from 'styled-components';
import { Button } from './Button';
import { ButtonContent } from './ButtonContent';
import { LayoutBox } from '../Layout/LayoutBox';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledContent = styled(LayoutBox).withConfig({
  displayName: "BorderButton__StyledContent",
  componentId: "eyx411-0"
})(["--background:var(--layout-lib-background-color-light);background-clip:content-box,border-box;background-color:var(--background);", " background-origin:border-box;block-size:2.5rem;border-radius:var(--layout-lib-border-radius);display:inline-block;", " ", " line-height:1;&:hover{--background:var(--layout-lib-background-color-breeze-extra-light);}a:has(&):hover{color:var(--layout-lib-text-color-primary);text-decoration:none;}a:has(&):focus-visible{outline:1px dotted ButtonText;outline:auto 1px -webkit-focus-ring-color;}", ""], ({
  $disabled
}) => $disabled ? `background-image: none;` : `background-image: linear-gradient(var(--background), var(--background)),
    var(--layout-lib-gradient-breeze-medium);`, ({
  $disabled
}) => $disabled ? `border: var(--layout-lib-border);` : `border: solid var(--layout-lib-border-width) transparent;`, ({
  theme
}) => `
    font-weight: ${theme.typography['heading-200'].fontWeight};
  `, ({
  $disabled
}) => $disabled && `
    color: var(--layout-lib-text-color-disabled);
    cursor: not-allowed;

    &:hover {
      --background: none;
    }
  `);
const Content = _ref => {
  let {
      children,
      disabled
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledContent, {
    $disabled: disabled,
    children: /*#__PURE__*/_jsx(ButtonContent, Object.assign({}, rest, {
      gap: "space-xs",
      insetBlockStart: "-space-4xs",
      paddingBlock: "space-sm",
      paddingInline: "space-md",
      position: "relative",
      children: children
    }))
  });
};
export const BorderButton = _ref2 => {
  let {
      children,
      href,
      disabled
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
    disabled: disabled,
    href: href,
    variant: "unstyled",
    children: /*#__PURE__*/_jsx(Content, {
      disabled: disabled,
      gap: "space-xs",
      isAnchor: !!href,
      children: children
    })
  }));
};